import { Component } from "react"
import PropTypes from "prop-types"
import { noop, isEqual } from "lodash"
import { Info } from "@mui/icons-material"
import { MenuItem } from "@mui/material"
import Tooltip from "components/material/tooltip"

class GroupingOption extends Component {
  static propTypes = {
    setGrouping: PropTypes.func.isRequired,
    grouping: PropTypes.object.isRequired,
    currentGrouping: PropTypes.object,
  }

  setGrouping = () => {
    const { setGrouping, grouping } = this.props
    setGrouping(grouping)
  }

  render() {
    const { grouping, currentGrouping } = this.props

    const label = <>
      {grouping.label}
      { grouping.disabled && grouping.disabledTooltip && <Tooltip title={grouping.disabledTooltip}><Info className="rollup-disabled-icon" /></Tooltip> }
    </>

    return <MenuItem
      disabled={grouping.disabled}
      selected={currentGrouping && isEqual(grouping, currentGrouping)}
      onClick={grouping.disabled ? noop : this.setGrouping}
    >
      {label}
    </MenuItem>
  }
}

export default GroupingOption
